module.exports = __webpack_public_path__ + "img/fructose.5299e908.jpg";